import { useNavigate } from "react-router-dom";

const withNumParam = (name: 'location' | 'building', p?: number) => {
  const params = new URLSearchParams(window.location.search);
  //const wasParams = params.toString();
  if (p !== undefined) {
    if (p < 0) {
      params.delete(name);
      if (name === 'location') params.delete('building');
    }
    else params.set(name, p.toString());
  }

  //dbg.trace("PARAMS", {result: params.toString(), name, p, wasParams});
  return `?${params.toString()}`;
}

const useLocationsNav = () => {
  const navigate = useNavigate();

  return  {
    setActiveLocation(id?: number) {
      navigate(withNumParam('location', id), { replace: true });
    },
    setActiveBuilding(id?: number) {
      navigate(withNumParam('building', id), { replace: true });      
    }
  };
};

export default useLocationsNav;